import React, { useMemo, useRef, useState } from "react";
import { RCCGrid } from "react-common-components";
import groupBy from "src/utils/groupArrayByKey";
import { useIndicatorsPanel } from "../../indicatorsPanelContext";
import CardIndicators from "../CardIndicators";
import { IIndicatorsMetrics, IIndicatorsValues, IListIndicators } from "../interface";
import ListIndicators from "../ListIndicators";
import TooltipIndicatorPanel from "../TooltipIndicatorPanel";
import { ITooltipIndicatorValues } from "../TooltipIndicatorPanel/interface";
import { IGroupIndicatorsComponent } from "./interface";


const GroupIndicators = ({
	data,
	options,
	showValues,
	filterList,
	layoutList,
	showHierarchyList,
	loadChildrens,
	openChartIndicators,
	childrenLevel,
	openValuesOfPeriodIndicator,
	defaultChecked
}: IGroupIndicatorsComponent) => {
	const {showCheckboxes} = useIndicatorsPanel();
	const [tooltipValue, setTooltipValue] = useState<ITooltipIndicatorValues | undefined>(undefined);

	const timer = useRef<number>(0);
	const mouseOverCardValuePanel = (value: IIndicatorsValues, description: string, iqc001Formaaval: number, metrics: IIndicatorsMetrics) => {
		timer.current = window.setTimeout(() => {
			setTooltipValue({
				...value,
				title: description,
				iqc001Formaaval ,
				metrics
			});
		}, 1000);
	};
	const mouseOutCardValuePanel = () => {
		window.clearTimeout(timer.current);
		setTooltipValue(undefined);
	};

	const MemoLists = useMemo(() => {
		const groupByIqb003Descricao = groupBy<IListIndicators>(["iqb003Descricao"]);
		const listData = groupByIqb003Descricao(data);
		return <RCCGrid container item direction="column">
			{layoutList === "list" ? (
				<>
					{Object.keys(listData).map((key) => <ListIndicators 
						key={`indicator-group-${key}`}
						data={listData[key]}
						options={(row: IListIndicators) => options(row)}
						showValues={showValues}
						filterList={filterList}
						showHierarchyList={showHierarchyList}
						loadChildrens={loadChildrens}
						openChartIndicators={openChartIndicators}
						childrenLevel={childrenLevel}
						openValuesOfPeriodIndicator={openValuesOfPeriodIndicator}
						defaultChecked={defaultChecked}
						mouseOverCardValuePanel={mouseOverCardValuePanel}
						mouseOutCardValuePanel={mouseOutCardValuePanel}
					/>)}
				</>
			): (
				<>
					{Object.keys(listData).map((key) => <CardIndicators 
						key={`indicator-group-${key}`}
						data={listData[key]}
						options={(row: IListIndicators) => options(row)}
						filterList={filterList}
						openValuesOfPeriodIndicator={openValuesOfPeriodIndicator}
						defaultChecked={defaultChecked}
					/>)}
				</>
			)}
		</RCCGrid>;
	}, [layoutList, data, filterList, showValues, showHierarchyList, defaultChecked, showCheckboxes]);

	return (
		<>
			{MemoLists}
			<TooltipIndicatorPanel
				value={tooltipValue}
			/>
		</>
	);
};

export default GroupIndicators;
